import { useTheme } from '@mui/material/styles';
import { bindActionCreators } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { TextField } from '@eatclubapp/ec-component-library';
import { connect } from 'react-redux';
import useStyles from './CleanTextFieldStyles';

/**
 * TODO need a way to set label for accessibility without setting a visible label
 */
const CleanTextField = ({
  label,
  value,
  onChange,
  autofocus,
  onFocus,
  onBlur,
  style,
  required,
  disabled,
  editable,
  error,
  showOutline,
  type,
  ...others
}) => {
  const theme = useTheme();
  const classes = useStyles({ style });
  return (
    <TextField
      className={classes.container}
      label={label}
      value={value}
      type={type}
      onChange={onChange}
      placeholder='Empty'
      autofocus={autofocus}
      onFocus={onFocus}
      onBlur={onBlur}
      required={required}
      disabled={disabled}
      editable={editable}
      error={error}
      {...others}
      style={{
        ...style,
        container: {
          ...style?.container,
        },
        innerContainer: {
          display: 'flex',
          gap: '10px',
          alignItems: 'baseline',
          ...style?.innerContainer,
        },
        label: {
          color: theme.colors.smoke,
          width: '100px',
          flexShrink: 0,
          marginBottom: 0,
          ...style?.label,
        },
        textFieldInner: {
          ...style?.textFieldInner,
        },
        input: {
          border: showOutline ? `1px solid ${theme.colors.shark}` : '1px solid transparent',
          width: '100%',
          color: disabled ? theme.colors.nimbus : theme.colors.charcoal,
          padding: '10px 14px',
          paddingLeft: '14px',
          borderRadius: '6px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          transition: 'background-color 0.1s',
          height: '36px',
          ...style?.input,
        },
        inputActive: {
          outline: `1px solid ${theme.colors.smoke}`,
          ...style?.inputActive,
        },
        inputHover: {
          backgroundColor: !disabled && theme.colors.yetAnotherGray12,
          ...style?.inputHover,
        },
        placeholder: {
          color: theme.colors.nimbus,
          ...style?.placeholder,
        },
        textField: {
          width: '100%',
          ...style?.textField,
        },
        errorText: {
          margin: '4px 0 0 110px',
          color: theme.colors.red,
          fontSize: '10px',
          ...style?.errorText,
        },
        inputPrefix: {
          ...style?.inputPrefix,
        },
        disabled: {
          backgroundColor: theme.colors.dateSelectBackground,
          borderRadius: '6px',
          ...style?.disabled,
        },
      }}
    />
  );
};

CleanTextField.defaultProps = {
  label: '',
  value: '',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  autofocus: false,
  style: {},
  required: false,
  disabled: false,
  editable: true,
  showOutline: false,
  error: null,
  type: 'text',
};

CleanTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autofocus: PropTypes.bool,
  style: PropTypes.shape({
    container: PropTypes.shape({}),
    innerContainer: PropTypes.shape({}),
    label: PropTypes.shape({}),
    textFieldInner: PropTypes.shape({}),
    input: PropTypes.shape({}),
    inputActive: PropTypes.shape({}),
    inputHover: PropTypes.shape({}),
    placeholder: PropTypes.shape({}),
    textField: PropTypes.shape({}),
    errorText: PropTypes.shape({}),
    inputPrefix: PropTypes.shape({}),
    disabled: PropTypes.shape({}),
  }),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  editable: PropTypes.bool,
  showOutline: PropTypes.bool,
  error: PropTypes.string,
  type: PropTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CleanTextField);
